import {
  IconBathroom,
  IconBedroom,
  IconCatalog,
  IconDining,
  IconFire,
  IconGarage,
  IconKitchen,
  IconLaundry,
  IconLiving,
  IconMudroom,
  IconNursery,
  IconOffice,
  IconOutdoor,
  IconShower,
} from '@/modules/product/components/icons';
import { ALGOLIA_SEARCH_INDEX } from '@/modules/product/services/consts';

const iconClassName = 'h-6 w-6 md:h-8 md:w-8';
export const ROOMTYPE_TO_ICON = {
  All: <IconCatalog className={iconClassName} />,

  Bathroom: <IconBathroom className={iconClassName} />,
  Bedroom: <IconBedroom className={iconClassName} />,
  'Dining Room': <IconDining className={iconClassName} />,
  Fire: <IconFire className={iconClassName} />,
  Garage: <IconGarage className={iconClassName} />,
  'Kids & Nursery': <IconNursery className={iconClassName} />,
  Kitchen: <IconKitchen className={iconClassName} />,
  'Laundry Room': <IconLaundry className={iconClassName} />,
  'Living Room': <IconLiving className={iconClassName} />,
  Mudroom: <IconMudroom className={iconClassName} />,
  Office: <IconOffice className={iconClassName} />,
  Outdoor: <IconOutdoor className={iconClassName} />,
  Shower: <IconShower className={iconClassName} />,
};

export const ROOMTYPE_FACET = 'fields.roomType.en-US';
export const ROOMSTYLE_FACET = 'fields.roomStyle.en-US';
export const COLLECTION_COLORS_FACET = 'fields.colors.en-US';
export const COLLECTION_TYPE_FACET = 'fields.collectionType.en-US';
export const COLLECTION_BRAND_FACET = 'fields.brand.en-US';
export const COLLECTION_BRAND_SLUG = 'brand';

export const PRODUCT_INDEX = ALGOLIA_SEARCH_INDEX;
